import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Stack,
  Box,
  Chip,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { TemplatePreview } from './SectionRenderer.style';
import ConnectIcon from 'components/Icons/connectIcon';

import TemplateItem from 'components/TemplateSubmissionPreview/TemplateItem/TemplateItem';

const SectionRenderer: React.FC<any> = ({
  key,
  item: section,
  childItemsMap,
  automations,
  onChangeCb,
  hideCorrectiveTask,
  error,
  allErrors,
  isPreview,
  isPublic,
  hideFeedback,
  log,
  parentSection,
  workspaceId,
  checkVisibility,
  checkListLogHashes,
}) => {
  const renderSectionHeader = (parentSection) => (
    <AccordionSummary
      expandIcon={<ExpandMoreIcon className="expandIcon" />}
      aria-controls="panel1-content"
      className="sectionAccordionSummary"
    >
      <Stack
        width="100%"
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        flexWrap={'wrap'}
        gap={'0px'}
      >
        {parentSection ? (
          <Stack direction="column" gap="5px">
            <Typography className="parentSectionTitle">
              {parentSection?.title}
            </Typography>
            <Stack direction="row" gap="3px">
              <ConnectIcon className="connectIcon" />
              <Typography className="sectionTitle">
                {section.title || section.description}
              </Typography>
            </Stack>
          </Stack>
        ) : (
          <Typography className="sectionTitle">
            {section.title || section.description}
          </Typography>
        )}
      </Stack>
    </AccordionSummary>
  );

  const renderItems = (items: any[]) => {
    if (!items) return null;
    return items.map((itemTemp) => {
      const item = log?.TaskChecklistItems?.find(
        (item) => item?.id === itemTemp?.id,
      );

      if (!checkVisibility?.(item)) return null;

      return (
        <div key={item.id}>
          <Box>
            <TemplateItem
              key={item.id}
              item={item}
              childItemsMap={childItemsMap}
              automations={automations}
              onChangeCb={(itm, value) => onChangeCb(itm, value)}
              hideCorrectiveTask
              error={error?.[item.id]}
              allErrors={allErrors}
              isPreview={false}
              isPublic={isPublic}
              hideFeedback={true}
              log={log}
              workspaceId={workspaceId}
              checkVisibility={checkVisibility}
              checkListLogHashes={checkListLogHashes}
            />
          </Box>
        </div>
      );
    });
  };

  const renderSubSections = (subSections: any[], parentSection: any) => {
    if (!subSections) return null;
    return subSections.map((subSection) => {
      if (!checkVisibility?.(subSection)) return null;

      return (
        <SectionRenderer
          key={subSection.id}
          item={subSection}
          childItemsMap={childItemsMap}
          automations={automations}
          onChangeCb={(itm, value) => onChangeCb(itm, value)}
          hideCorrectiveTask
          error={allErrors?.[subSection.id]}
          allErrors={allErrors}
          isPreview={false}
          isPublic={isPublic}
          hideFeedback={true}
          log={log}
          workspaceId={workspaceId}
          parentSection={parentSection}
          checkVisibility={checkVisibility}
          checkListLogHashes={checkListLogHashes}
        />
      );
    });
  };

  return (
    <TemplatePreview
      sx={{
        ...(parentSection && {
          marginLeft: '20px !important',
        }),
      }}
    >
      <Accordion
        className="sectionAccordion"
        TransitionProps={{ unmountOnExit: true }}
        defaultExpanded
        disableGutters
        square={false}
      >
        {renderSectionHeader(parentSection)}
        <AccordionDetails sx={{ px: 0, pb: 0 }}>
          <Stack spacing={2}>
            {renderItems(section?.TaskChecklistItems)}
            {renderSubSections(section?.subSections, section)}
          </Stack>
        </AccordionDetails>
      </Accordion>
    </TemplatePreview>
  );
};

export default SectionRenderer;
